<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="elevation-12 pa-4">
                    <v-card-title class="title-color mb-0 pb-0" >
                        <v-row>
                            <v-col cols="3">KPIs</v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-select
                                    label="Selector de KPIs"
                                    v-model="kpi"
                                    :items="kpi_items"
                                    hide-details
                                    return-object
                                    @change="search()"
                                ></v-select>
                            </v-col>
                            <v-col cols="2">
                                <JobProgress v-if="kpi.excel" v-model="downloadJobState" v-on:done="jobDone" :job_id="asyncJobId">
                                    <template v-slot:progress>
                                        <v-progress-circular
                                            v-if="downloadJobState==='running'"
                                            indeterminate
                                            class="mr-2"              
                                            color="primary"
                                        ></v-progress-circular>
                                    </template>
                                    <template v-slot:quiet>
                                        <v-btn color="primary" @click="downloadExcel()">
                                            <v-icon v-once>
                                                mdi-file-excel
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                </JobProgress>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="3">
                                <v-select
                                    v-if="['get_kpis_document_data', 'get_kpis_leads_data'].includes(kpi.value)"
                                    :items="trimester_items"
                                    v-model="trimester"
                                    label="Trimestre"
                                ></v-select>
                                <v-row v-else-if="['get_kpis_percent_cdbtype', 'get_kpis_user_without_recent_login','get_kpis_doc_errors'].includes(kpi.value)">
                                    <v-col cols="9" >
                                        <date-picker
                                            aucomplete="off"
                                            label="Fecha Inicio" 
                                            v-model="date_ini"
                                        ></date-picker>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn @click="date_ini=''">
                                            <v-icon v-once>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    v-if="['get_kpis_document_data', 'get_kpis_leads_data'].includes(kpi.value)"
                                    :items="year_items"
                                    v-model="year"
                                    label="Año"
                                ></v-select>
                                <v-autocomplete
                                    v-else-if="['get_kpis_simulations_data', 'get_kpis_simulation_states_count_data'].includes(kpi.value)"
                                    autocomplete="off"
                                    label="Empresa" 
                                    v-model="company"
                                    :items="get_companydbs"
                                    item-text="name"
                                    return-object
                                    hide-details
                                    @change="search()"
                                ></v-autocomplete>
                                <v-row v-else-if="['get_kpis_percent_cdbtype'].includes(kpi.value)">
                                    <v-col cols="9" >
                                        <date-picker
                                            aucomplete="off"
                                            label="Fecha Final" 
                                            v-model="date_end"
                                        ></date-picker>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn @click="date_end=''">
                                            <v-icon v-once>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                
                            </v-col>
                            <v-col cols="2">
    
                                <v-select
                                    v-if="['get_kpis_document_data'].includes(kpi.value)"
                                    :items="docs_values"
                                    v-model="show_doc"
                                    label="Tipo de documentos"
                                ></v-select>

                            </v-col>
                            <v-col v-if="['get_kpis_doc_errors'].includes(kpi.value)" cols="1">
                                <v-checkbox v-model="update_table" label="Recalcular datos" />
                            </v-col>
                            <v-col v-else cols="1"></v-col>
                            <v-col cols="1">
                                <v-btn color="primary" :loading="loading" rounded v-on:click="search()">
                                    Buscar
                                </v-btn>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field 
                                    v-if="kpi_written_date && kpi.value != 'get_kpis_doc_errors'"
                                    regular
                                    color="primary" 
                                    label="Última actualización de la caché" 
                                    v-model="kpi_written_date" 
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="kpi.value == 'get_kpis_doc_errors'">
                            <v-col >
                                <div :id="'errors_table'" style="{width:100%}"></div>
                            </v-col>
                        </v-row>
                        <KpiTablePercentCDBType v-if="['get_kpis_percent_cdbtype'].includes(kpi.value)"></KpiTablePercentCDBType>
                        <v-row v-else-if="['get_kpis_user_without_recent_login'].includes(kpi.value)">
                            <v-col cols="12" v-if="Boolean(Object.keys(kpis_data).length)">
                                <v-data-table
                                    :headers="[{'text': 'Usuario', 'value': 'username'}, {'text': 'Fecha', 'value': 'date'}, {'text': 'Documento', 'value': 'document'}]"
                                    :items="kpis_data['params']"
                                ></v-data-table>
                            </v-col>
                        </v-row>
                        <JobProgress v-else v-model="tableJobState" v-on:done="tableJobDone" :job_id="tableAsyncJobId">
                            <template v-slot:progress>
                                <v-progress-circular
                                    v-if="tableJobState==='running'"
                                    indeterminate
                                    color="primary"
                                ></v-progress-circular>
                            </template>
                            <template v-slot:quiet>
                                <div v-if="Boolean(Object.keys(kpis_data).length)">
                                    <kpi-table-doc v-if="['get_kpis_document_data'].includes(kpi.value)"></kpi-table-doc>
                                    <kpi-table v-else-if="['get_kpis_leads_data'].includes(kpi.value)"></kpi-table>
                                    <!-- <kpi-table-simulations v-else-if="['get_kpis_simulations_data', 'get_kpis_simulation_states_count_data'].includes(kpi.value)"></kpi-table-simulations> -->
                                    <kpi-table-simulations-data v-else-if="['get_kpis_simulations_data'].includes(kpi.value)" :cdb="company"></kpi-table-simulations-data>
                                    <kpi-table-simulation-states-count-data v-else-if="['get_kpis_simulation_states_count_data'].includes(kpi.value)" :cdb="company"></kpi-table-simulation-states-count-data>
                                </div>
                            </template>
                        </JobProgress>

                        <Browser v-if="kpi.value=='get_kpis_document_data'" :filters="Object.keys(kpi_filters_docs).join('')" :searchFunc="filter_func" :cleanFunc="clean_filters" :fab="true">
                            <template v-slot:inputs>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field 
                                            autocomplete="off" 
                                            label="Nombre de usuario" 
                                            v-model="filters['username']" 
                                            v-on:keyup.enter="filter_func"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-checkbox
                                            v-model="filters['show_trials']"
                                            label="Mostrar usuarios Trial"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-checkbox
                                            v-model="filters['show_staff']"
                                            label="Mostrar usuarios de staff"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-checkbox
                                            v-model="filters['show_unactive']"
                                            label="Mostrar usuarios inactivos"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </template>
                        </Browser>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
// import DocTextField from '../components/DocTextField.vue';
import KpiTable from '../components/KpiTable.vue';
import KpiTableDoc from '../components/KpiTableDoc.vue';
// import KpiTableSimulations from '../components/KpiTableSimulations.vue';
import KpiTableSimulationsData from '../components/KpiTableSimulationsData.vue';
import KpiTableSimulationStatesCountData from '../components/KpiTableSimulationStatesCountData.vue';
import KpiTablePercentCDBType from '../components/KpiTablePercentCDBType.vue';
import DatePicker from '../components/DatePicker.vue'
// import KpiTableHeader from '../components/KpiTableHeader.vue';
// import KpiTableRow from '../components/KpiTableRow.vue';
import Browser from '../components/Browser.vue';
import JobProgress from '../components/JobProgress.vue';
import { jobs } from '../api/jobs.js';
import { vuexPrefix } from "../store/vuex_utils";

export default {
    components: {
        // DocTextField,
        KpiTable,
        KpiTableDoc,
        // KpiTableSimulations,
        KpiTableSimulationsData,
        KpiTableSimulationStatesCountData,
        KpiTablePercentCDBType,
        // KpiTableHeader,
        // KpiTableRow,
        Browser,
        JobProgress,
        DatePicker,
    },
    data() {
        return {
            loading: false,

            // downloadJobState: "done",
            // asyncJobId: 0,
            downloading: false,
            filters: {
                'show_trials': true,
                'show_staff': false,
                'show_unactive': false,
            },
            update_table:false,
        };
    },
    computed:{
        ...mapGetters([
            'get_companydbs',
        ]),
        ...mapState([
            'currentCompany',
            // 'session_information',
        ]),
        ...mapFields('kpis', [
            'kpi', 
            'kpi_items', 
            'trimester', 
            'trimester_items', 
            'year', 
            'year_items', 
            'downloadJobState', 
            'asyncJobId',

            'tableAsyncJobId',
            'tableJobState',

            'docs_values',
            'show_doc',
            'kpi_written_date',
            'company',
            'kpi_filters',

            'kpis_data',
            'date_ini',
            'date_end',
        ]),
        ...mapFields('me', ['userData']),
        ...mapFields('kpis', vuexPrefix('kpi_filters_', ['docs'],'kpi_filters.')),
    },
    mounted() {
        
        if (!this.year || !this.trimester) {
            this.getInitialDate();
        }
        if (!Object.keys(this.company).length) {
            this.company = this.currentCompany;
        }
        this.search();
    },
    methods: {
        ...mapActions({
            getKpis: "kpis/getKpis",
            downloadExcel: "kpis/downloadExcel",
            refreshUserData: "me/refreshUserData",
            filterKpis: "kpis/filterKpis",
            tableJobDone: "kpis/tableJobDone",
            getHistogram: "kpis/getHistogram",
        }),
        getInitialDate() {
            let date = new Date();
            let y = date.getFullYear();
            this.year = y.toString();
            let month = date.getMonth();
            if (month < 3) {
                this.trimester = '-01-01';
            } else if (month < 6) {
                this.trimester = '-04-01';
            } else if (month < 9) {
                this.trimester = '-07-01';
            } else {
                this.trimester = '-10-01';
            }
        },
        search() {
            if(this.kpi.value != 'get_kpis_doc_errors'){
                this.loading = true;
                this.getKpis().then(() => {
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            }
            else{
                this.get_errors_table()
            }
        },
        async get_errors_table() {
            this.loading = true;
            let inner = document.getElementById('errors_table');
            if (inner)
                inner.innerHTML = "";
            let date = this.date_ini
            if(!date){
                date = new Date()
                date =this.formatDate(date)
            }

            let url = '/get_kpis_errors_table/'+ '?date_ini=' + date + '&update=' + this.update_table//yyyy-mm-dd
            this.getHistogram(url).then(resp => {
                this.loading=false
                setTimeout(function() {
                    window.Bokeh.embed.embed_item(resp.data);
                });
            });
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [year, month, day].join('-');
        },
        async jobDone() {
            this.downloading=true;
            const response = await jobs.getJobFile({ id: this.asyncJobId });
            let fileURL = response.data.url;
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "kpis.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            this.downloading=false;
        },
        filter_func() {
            this.kpi_filters_docs = JSON.parse(JSON.stringify(this.filters));
        },
        clean_filters() {
            this.filters = {
                'is_staff': this.filters.is_staff,
                'is_active': this.filters.is_active,
                'is_trial': this.filters.is_trial,
            };
            this.filter_func();
        }
    },
};
</script>

<style scoped>
    .title-color {
        color:var(--v-primary-base);
    }
</style>
